import Navbar from 'components/navbar';
import classes from './scheduleAttainment.module.scss';
import { getDate } from 'utils/dateUtilities';
import { Button } from 'primereact/button';
import { PrinterIcon } from 'lucide-react';
import { useScheduleAttainment } from './useScheduleAttainment.logic';
import ScheduleAttainmentByRoomScreen from './components/ScheduleAttainmentByRoomScreen';
import { observer } from 'mobx-react-lite';

const ScheduleAttainmentScreen = () => {
  const {
    loading,
    scheduleAttainmentByRoomFirstShift,
    scheduleAttainmentByRoomSecondShift,
    scheduledRooms,
    handlePrint
  } = useScheduleAttainment();

  return (
    <div className={classes.scheduleAttainmentScreenContainer}>
      <Navbar heading="Schedule Attainment" />
      <div className={classes.content}>
        <div className={classes.headerRow}>
          <div className={classes.dateContainer}>
            <p>
              <span style={{ color: '#4D2E6D', fontWeight: '600' }}>Date: </span>
              {getDate()}
            </p>
          </div>
          <div className={classes.printButtonContainer}>
            <Button
              icon={<PrinterIcon color="#4D2E6D" />}
              rounded
              style={{ backgroundColor: '#D6B1FD', border: 'none' }}
              onClick={handlePrint}
              disabled={loading}
            />
          </div>
        </div>

        <div className={classes.purpleHeader}>
          <h2>Schedule Attainment Calculator by Room</h2>
        </div>

        <ScheduleAttainmentByRoomScreen
          scheduleAttainmentByRoomFirstShift={scheduleAttainmentByRoomFirstShift}
          scheduleAttainmentByRoomSecondShift={scheduleAttainmentByRoomSecondShift}
          scheduledRooms={scheduledRooms}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default observer(ScheduleAttainmentScreen);
